export const projects = [
	{
		img: 'https://blog.unfranchise.com/wp-content/uploads/2017/06/Shop-Exclusive-Brands-1.jpg',
		title: 'Shop Clone',
		des: 'SHOP.COM is a comparison shopping site enabling online shoppers to purchase in various partner stores using one shopping cart.',
		demo: '',
		live: 'https://shop-clone-com.netlify.app/',
		gitHub: 'https://github.com/kajalyadavgithub/Shop.com-clone',
		technologies: ['JavaScript,',"HTML," ,'CSS'],
		
	},
	{
		img: 'https://d3pettoeguc9mf.cloudfront.net/pic/412x227/g/greenhouse.io.png',
		title: 'Greenhouse Clone',
		des: 'Greenhouse is the leading hiring software for growing companies. Thousands of the most successful companies, like DoorDash, Betterment, Wayfair and DocuSign, use Greenhouse to optimize all aspects of their hiring and onboarding.',
		demo: '',
		live: 'https://greenhouseclone.netlify.app/',
		gitHub: 'https://github.com/Ni3deshwal/GreenHouseClone',
		technologies: ['JavaScript,',"HTML," ,'CSS,'],
	},
	{
		img: 'https://user-images.githubusercontent.com/113697547/213976509-ffd7e261-776b-4a73-a50b-2480d660a636.png',
		title: 'Zostel Clone',
		des: 'Zostel is that its is a hostel for backpackers. In Zostel there are shared rooms a common dining room, and a variety of enjoyable activities.',
		demo: '',
		live: 'https://zostel.vercel.app/',
		gitHub: 'https://github.com/DenishFuletra/zostel-clone',
		technologies: ['React,','Redux,','JavaScript,',"HTML," ,'CSS,'],
	}

];
